import {
  filterEmptyLocalisedValues,
  filterEmptyMediaUrls,
} from "@/app/core-module/util/coreHelper";

export const getTrainingModuleContentInput = trainingModuleContent => {
  const input = {
    _id: trainingModuleContent._id,
    contentType: trainingModuleContent.contentType,
    duration: trainingModuleContent.duration,
    displayPosition: trainingModuleContent.displayPosition,
  };

  if (trainingModuleContent.title) {
    const localisedTitles =
      filterEmptyLocalisedValues(trainingModuleContent.title) ?? [];

    if (localisedTitles.length) input.title = localisedTitles;
  }

  if (trainingModuleContent.description) {
    input.description =
      filterEmptyLocalisedValues(trainingModuleContent.description) ?? [];
  }

  if (
    input.contentType === "VIDEO" &&
    trainingModuleContent.trainingModuleContentVideos
  ) {
    const videos = filterEmptyMediaUrls(
      trainingModuleContent.trainingModuleContentVideos
    );

    if (videos.length) input.videos = videos;

    input.audios = [];
    input.text = [];
    input.quiz = {};
  } else if (
    input.contentType === "AUDIO" &&
    trainingModuleContent.trainingModuleContentAudios
  ) {
    const audios = filterEmptyMediaUrls(
      trainingModuleContent.trainingModuleContentAudios
    );

    if (audios.length) input.audios = audios;

    input.videos = [];
    input.text = [];
    input.quiz = {};
  } else if (input.contentType === "TEXT" && trainingModuleContent.text) {
    input.text = filterEmptyLocalisedValues(trainingModuleContent.text) ?? [];

    input.videos = [];
    input.audios = [];
    input.quiz = {};
  } else if (
    input.contentType === "QUIZ" &&
    (trainingModuleContent.quiz || trainingModuleContent.quizContent)
  ) {
    if (trainingModuleContent.quiz?.questionAnswers?.length) {
      trainingModuleContent.quiz.questionAnswers =
        trainingModuleContent.quiz.questionAnswers.map(
          (questionAnswer, questionAnswerIndex) => {
            return {
              _id: questionAnswer._id,
              question:
                filterEmptyLocalisedValues(questionAnswer.question) ?? [],
              choices: questionAnswer.choices?.map(choice => {
                return {
                  key: choice.key,
                  value: filterEmptyLocalisedValues(choice.value) ?? [],
                };
              }),
              answerKey: questionAnswer.answerKey,
              mark: questionAnswer.mark,
              displayPosition: questionAnswerIndex, //questionAnswer.displayPosition,//removed for dragging,
            };
          }
        );

      input.quiz = {
        timeOut: trainingModuleContent.quiz.timeOut,
        passMark: trainingModuleContent.quiz.passMark,
        retryCount: trainingModuleContent.quiz.retryCount,
        questionAnswers: trainingModuleContent.quiz.questionAnswers,
        questionsDisplayedCount:
          trainingModuleContent.quiz.questionsDisplayedCount,
      };
    }

    if (trainingModuleContent.quizContent) {
      input.quizContent =
        trainingModuleContent.quizContent?._id ??
        trainingModuleContent.quizContent;
    }

    input.videos = [];
    input.audios = [];
    input.text = [];
  }

  return input;
};
